.prev::before {
  content: "←"
}
.next::after {
  content: "→"
}
